function About() {
  return (
    <div className="py-20">
      <div className="container-width section-padding">
        {/* Hero Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            About <span className="text-secondary">TVBA</span>
          </h1>
          <p className="text-xl text-white max-w-3xl mx-auto">
            A vibrant and dynamic non-profit organisation supporting local businesses in the Tamar Valley region
          </p>
        </div>

        {/* Main Content */}
        <div className="max-w-4xl mx-auto">
          {/* Mission Section */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold mb-6 text-white">Our Mission</h2>
            <p className="text-lg text-white leading-relaxed mb-6">
              The Tamar Valley Business Association (TVBA) is a vibrant and dynamic non-profit organisation 
              nestled in the picturesque Tamar Valley region of Northern Tasmania. Our primary objective is 
              to foster and support local businesses within our community.
            </p>
            <p className="text-lg text-white leading-relaxed">
              At TVBA, we are passionate about promoting economic growth and development in the Tamar Valley. 
              Through various initiatives and programs, we aim to empower entrepreneurs, small business owners, 
              and professionals to thrive in this thriving region.
            </p>
          </div>

          {/* Benefits Section */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold mb-8 text-white">Member Benefits</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="p-6">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4" style={{ backgroundColor: 'rgb(165, 104, 36)' }}>
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-3" style={{ color: 'rgb(232, 188, 130)' }}>Networking Opportunities</h3>
                <p className="text-white">Connect with like-minded entrepreneurs and professionals in the region</p>
              </div>

              <div className="p-6">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4" style={{ backgroundColor: 'rgb(165, 104, 36)' }}>
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-3" style={{ color: 'rgb(232, 188, 130)' }}>Valuable Resources</h3>
                <p className="text-white">Access to business development tools, training materials, and expert advice</p>
              </div>

              <div className="p-6">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4" style={{ backgroundColor: 'rgb(165, 104, 36)' }}>
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-3" style={{ color: 'rgb(232, 188, 130)' }}>Business Workshops</h3>
                <p className="text-white">Participate in educational workshops designed to enhance your business skills</p>
              </div>

              <div className="p-6">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-4" style={{ backgroundColor: 'rgb(165, 104, 36)' }}>
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                  </svg>
                </div>
                <h3 className="text-xl font-semibold mb-3" style={{ color: 'rgb(232, 188, 130)' }}>Promotional Events</h3>
                <p className="text-white">Showcase your business at our regular promotional events and markets</p>
              </div>
            </div>
          </div>

          {/* Member Experience Section */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold mb-6 text-white">The TVBA Experience</h2>
            <p className="text-lg text-white leading-relaxed mb-6">
              Members of TVBA enjoy a range of exclusive benefits, including networking opportunities, access to 
              valuable resources, business workshops, and promotional events. Whether you're just starting your 
              venture or have been a seasoned business owner for years, joining TVBA opens doors to new connections, 
              knowledge sharing, and potential collaborations.
            </p>
          </div>

          {/* Local Products Section */}
          <div className="mb-12">
            <h2 className="text-3xl font-bold mb-6 text-white">Supporting Local Excellence</h2>
            <p className="text-lg text-white leading-relaxed mb-6">
              Additionally, we take pride in showcasing the diverse range of products and services offered by our 
              member businesses. The Tamar Valley is renowned for its quality produce, boutique wineries, artisanal 
              products, and unique crafts. The Exeter markets, held regularly, serve as a vibrant hub for local 
              entrepreneurs to showcase their offerings and connect with the community.
            </p>
          </div>

          {/* Call to Action */}
          <div className="text-white p-8 md:p-12 text-center">
            <h2 className="text-3xl font-bold mb-6">Ready to Join Our Community?</h2>
            <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto">
              For any membership inquiries, partnership opportunities, or general information, please feel free to 
              contact us or visit us at the Exeter markets. We are always delighted to welcome new members and 
              collaborate with individuals who share our vision for a thriving business community in the Tamar Valley.
            </p>
            <p className="text-lg text-gray-300 mb-8 max-w-3xl mx-auto">
              Remember, together we can nurture economic growth, create sustainable businesses, and strengthen the 
              Tamar Valley's position as a hub for innovation and prosperity. Join TVBA today and take advantage of 
              the endless possibilities that await you in our breathtaking region!
            </p>
            <div className="flex justify-center">
              <a 
                href="/contact"
                className="btn-primary"
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About 